module.exports = __webpack_public_path__ + "static/media/gif02.f076ad5f.gif";